module.exports = __webpack_public_path__ + "static/media/tab-post.365df67d.png";